
<template>
  <div id="data-list-list-view" class="data-list-container">

    <data-view-sidebar :isSidebarActive="addNewDataSidebar" @closeSidebar="toggleDataSidebar" :data="sidebarData" />

    <vs-table ref="table" pagination :max-items="itemsPerPage" search :data="productcategories">

      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

        <div class="flex flex-wrap-reverse items-center data-list-btn-container">

          <!-- ACTION - DROPDOWN -->

          <!-- ADD NEW -->
          <div class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary" @click="addNewData">
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
              <span class="ml-2 text-base text-primary">Add New</span>
          </div>

          <!-- EXPORT EXCEL -->
          <vs-button color="success" class="ml-2 mb-4 flex items-center" @click="exportExcel">
          <feather-icon icon="DownloadIcon" svgClasses="h-4 w-4 mr-2" />
          Export Excel (Active)
        </vs-button>
        </div>

        <!-- ITEMS PER PAGE -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
          <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ productcategories.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : productcategories.length }} of {{ queriedItems }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>

            <vs-dropdown-item @click="itemsPerPage=5">
              <span>5</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=20">
              <span>20</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=50">
              <span>50</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=100">
              <span>100</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th sort-key="name_en">#</vs-th>
        <vs-th sort-key="name_en">Name EN</vs-th>
        <vs-th sort-key="name_fr">Name FR</vs-th>
        <vs-th sort-key="name_ro">Name RO</vs-th>
        <vs-th sort-key="name_ro">Name ES</vs-th>
        <vs-th sort-key="name_ro">Name DE</vs-th>
        <vs-th sort-key="name_ro">Name NL</vs-th>
        <vs-th sort-key="name_ro">Name Punjabi</vs-th>
        <vs-th sort-key="name_ro">Shape</vs-th>
        <vs-th sort-key="name_ro">Ref. Price (€/m3)</vs-th>
        <vs-th sort-key="active">Sumal Required when Transported?</vs-th>
        <vs-th sort-key="active">Active</vs-th>
        <vs-th>Action</vs-th>
      </template>

        <template slot-scope="{data}">
          <tbody>
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td>
                <p>{{ tr.id }}</p>
              </vs-td>
              <vs-td>
                <p class="font-medium truncate">{{ tr.name_en }}</p>
              </vs-td>
              <vs-td>
                <p>{{ tr.name_fr }}</p>
              </vs-td>

              <vs-td>
                <p>{{ tr.name_ro }}</p>
              </vs-td>

              <vs-td>
                <p>{{ tr.name_es }}</p>
              </vs-td>

              <vs-td>
                <p>{{ tr.name_de }}</p>
              </vs-td>

              <vs-td>
                <p>{{ tr.name_nl }}</p>
              </vs-td>

              <vs-td>
                <p class="punjabi-text">{{ tr.name_punjabi }}</p>
              </vs-td>

              <vs-td>
                <vs-chip :color="getActiveColors(tr.productcategoryshape.name_en)">{{ tr.productcategoryshape.name_en }}</vs-chip>
              </vs-td>

              <vs-td>
                <p>{{ tr.price }}</p>
              </vs-td>

              <vs-td>
                <vs-chip :color="getActiveColors(tr.needsumal)">{{ tr.needsumal }}</vs-chip>
              </vs-td>
              <vs-td>
                <vs-chip :color="getActiveColors(tr.isactive)">{{ tr.isactive }}</vs-chip>
              </vs-td>

              <vs-td class="whitespace-no-wrap">
                <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" @click.stop="editData(tr)" />
              </vs-td>

            </vs-tr>
          </tbody>
        </template>
    </vs-table>
  </div>
</template>

<script>
import DataViewSidebar from './DataViewSidebar.vue'
import moduleDataListProductCategory from '@/store/products/productcategory/moduleDataList.js'
import * as XLSX from 'xlsx'

export default {
  components: {
    DataViewSidebar
  },
  data () {
    return {
      selected: [],
      itemsPerPage: 5,
      isMounted: false,

      // Data Sidebar
      addNewDataSidebar: false,
      sidebarData: {}
    }
  },
  computed: {
    currentPage () {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    productcategories () {
      return this.$store.state.dataListProductCategory.productcategories
    },
    queriedItems () {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.productcategories.length
    }
  },
  methods: {
    addNewData () {
      this.sidebarData = {}
      this.toggleDataSidebar(true)
    },
    editData (data) {
      // this.sidebarData = JSON.parse(JSON.stringify(this.blankData))
      //console.log(optionslanguages)
      this.sidebarData = data
      this.toggleDataSidebar(true)
    },
    getActiveColors (status) {
      if (status === true)   return 'primary'
      if (status === false) return 'danger'
      return 'black'
    },
    toggleDataSidebar (val = false) {
      this.addNewDataSidebar = val
    },
    exportExcel () {
      if (!this.productcategories || this.productcategories.length === 0) {
        this.$vs.notify({
          title: 'Error',
          text: 'No data to export.',
          color: 'warning',
          position: 'top-right'
        })
        return
      }

      // Filtrer uniquement les éléments actifs
      const activeCategories = this.productcategories.filter(tr => tr.isactive === true)

      if (activeCategories.length === 0) {
        this.$vs.notify({
          title: 'Warning',
          text: 'No active categories to export.',
          color: 'warning',
          position: 'top-right'
        })
        return
      }

      const data = activeCategories.map(tr => ({
        ID: tr.id || '',
        'Name EN': tr.name_en || '',
        'Name FR': tr.name_fr || '',
        'Name RO': tr.name_ro || '',
        'Name ES': tr.name_es || '',
        'Name DE': tr.name_de || '',
        'Name NL': tr.name_nl || '',
        'Name Punjabi': tr.name_punjabi || '',
        'Shape': tr.productcategoryshape && tr.productcategoryshape.name_en ? tr.productcategoryshape.name_en : '',
        'Ref. Price (€/m3)': tr.price || '',
        'Sumal Required when Transported?': tr.needsumal === true ? 'Yes' : tr.needsumal === false ? 'No' : '',
        'Active': tr.isactive === true ? 'Yes' : tr.isactive === false ? 'No' : ''
      }))

      const worksheet = XLSX.utils.json_to_sheet(data)
      const workbook = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Product Categories')

      const fileName = `product_categories_active_export_${new Date().toISOString().split('T')[0]}.xlsx`
      XLSX.writeFile(workbook, fileName)

      this.$vs.notify({
        title: 'Success',
        text: `Excel export successful. ${activeCategories.length} active categor${activeCategories.length > 1 ? 'ies' : 'y'} exported.`,
        color: 'success',
        position: 'top-right'
      })
    }
  },
  created () {
    if (!moduleDataListProductCategory.isRegistered) {
      this.$store.registerModule('dataListProductCategory', moduleDataListProductCategory)
      moduleDataListProductCategory.isRegistered = true
    }
    this.$store.dispatch('dataListProductCategory/fetchDataListItems')
  },
  mounted () {
    this.isMounted = true
  }
}
</script>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {

    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new,
        .btn-export {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search{
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 20px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
          }
          td.td-check{
            padding: 20px !important;
          }
      }
    }

    .vs-table--thead{
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text{
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check{
        padding: 0 15px !important;
      }
      tr{
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}

// Style for Punjabi text in table
.punjabi-text {
  font-family: 'Noto Sans Gurmukhi', sans-serif !important;
  font-size: 14px;
}
</style>
